
export const twinfieldState: aboTheme.IState = {
    parent: 'app',
    name: "twinfield",
    url: "/twinfield",
    component: 'twinfieldOAuthCallbackComponent'
};



// WEBPACK FOOTER //
// ./src/app/modules/twinfield/twinfield.states.ts